import React  from "react";
import { connect } from "react-redux";
import "../../../Dashboard/dashboard.css";
import { useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import {
  generateForecastMaintenanceAndGrowthCapex,
  updateForecastMaintenanceAndGrowthCapex
} from "../../../../store/modules/forecastMGC/actions";
import CurrencyFormatter from "currency-formatter";
import FinancialHandler from "../../../../handlers/FinancialHandler";

const ForecastMGC = ({
  appState,
  forecastMaintenanceAndGrowthCapex,
  dispatchGenerateForecastMaintenanceAndGrowthCapex,
  dispatchUpdateForecastMaintenanceAndGrowthCapex
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateForecastMaintenanceAndGrowthCapex()
  }, [])

  const handleChange = (key, value) => {
    dispatchUpdateForecastMaintenanceAndGrowthCapex({
      [key]: key === "analystNote" ? value : CurrencyFormatter.unformat(value, { code: "USD" })
    })
  }

  const handleOnClickGPT = async () => {
    handleChange("analystNote", "Generating...");
    const payload =
      "Based on our forecasted revenue, we input the percentage of capital expenditures required to fund our growth in revenue. This gives us our forecasted annual capital expenditure investment for the next year.\nHere are the company's capital expenditure forecast data." +
      "\nRevenue Estimate: " + Number(forecastMaintenanceAndGrowthCapex?.forecastedRevenue).toFixed(2) + "$" +
      "\nCapex Percentage of Revenue: " + Number(forecastMaintenanceAndGrowthCapex?.capexPercentageRevenue).toFixed(2) + "%" +
      "\nCapital Expenditure Amount: " + Number(forecastMaintenanceAndGrowthCapex?.capitalExpenditureAmount).toFixed(2) + "$" +
      "\nGrowth Rate: " + Number(forecastMaintenanceAndGrowthCapex?.growthRate * 100 - 100).toFixed(2) + "%" +
      "\nForecasted Capital Expenditure: " + Number(forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex).toFixed(2) + "$" +
      "\nPlease analyze this company's forecasted Capital Expenditures situation."
    const note = await FinancialHandler.fetchGPTSimpleNoteGeneration(payload);
    handleChange("analystNote", note);
  }

  return (
    <>
      <h2 className="sectionHead">Forecasted Capital Expenditures</h2>
        <div className="dashboard-content">
          <div className="data-title-container">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Capital Expenditure Long-Term Forecast</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Revenue Estimate</InputLabel>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "50%",
              }}
            >
              <BVAInput
                disabled
                size="small"
                id="mgc-forcastedRevenue"
                startAdornment
                startAdornmentLabel="$"
                value={(forecastMaintenanceAndGrowthCapex?.forecastedRevenue)?.toFixed(2)}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Capex % of Revenue</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                size="small"
                id="mgc-fiveYearIndustryAverageCapex"
                endAdornment
                textAlign="end"
                endAdornmentLabel="%"
                startAdornment
                startAdornmentLabel="x"
                onChange={(value) => handleChange("capexPercentageRevenue", value)}
                value={forecastMaintenanceAndGrowthCapex?.capexPercentageRevenue}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Capital Expenditure Amount</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="mgc-capitalExpenditureAmount"
                startAdornment
                startAdornmentLabel="$"
                value={forecastMaintenanceAndGrowthCapex?.capitalExpenditureAmount}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>1 + Growth Rate</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="mgc-growthRate"
                startAdornment
                startAdornmentLabel="x"
                value={forecastMaintenanceAndGrowthCapex?.growthRate?.toFixed(5)}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Forecasted Annual Capex
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="mgc-forcastedValue"
                startAdornment
                startAdornmentLabel="$"
                value={forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex}
              />
            </div>
          </div>

          <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
            <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
            <textarea
              className="analystNote"
              rows={3}
              value={forecastMaintenanceAndGrowthCapex?.analystNote}
              onChange={(e) => handleChange("analystNote", e.target.value)}
            />
          </div>
        </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  appState: state.appState,
  forecastMaintenanceAndGrowthCapex: state.forecastMGC.forecastMaintenanceAndGrowthCapex
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateForecastMaintenanceAndGrowthCapex() {
    dispatch(generateForecastMaintenanceAndGrowthCapex())
  },

  dispatchUpdateForecastMaintenanceAndGrowthCapex({ capexPercentageRevenue, analystNote }) {
    dispatch(updateForecastMaintenanceAndGrowthCapex({ capexPercentageRevenue, analystNote }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForecastMGC);
